// @flow
import { TOGGLE_FAVOURITE_EVENT } from '../../actions/live/actions';
import { createToggleFavoritesReducer } from '../../../utils';

export const favouriteEventIds = createToggleFavoritesReducer(
  TOGGLE_FAVOURITE_EVENT
);
